"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentChatConversationOwnerIdSchema = exports.agentChatConversationIdSchema = exports.conversationSummaryDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.conversationSummaryDtoSchema = zod_1.z.object({
    id: (0, cadstrom_shared_1.cadstromUidSchema)(cadstrom_shared_1.CadstromObjectType.AgentChatConversation),
    sessionId: zod_1.z.string(),
    title: zod_1.z.string().nullable(),
    lastActivityAt: zod_1.z.date(),
    createdAt: zod_1.z.date(),
});
exports.agentChatConversationIdSchema = (0, cadstrom_shared_1.cadstromUidSchema)(cadstrom_shared_1.CadstromObjectType.AgentChatConversation);
exports.agentChatConversationOwnerIdSchema = zod_1.z.union([
    (0, cadstrom_shared_1.cadstromUidSchema)(cadstrom_shared_1.CadstromObjectType.User),
    (0, cadstrom_shared_1.cadstromUidSchema)(cadstrom_shared_1.CadstromObjectType.Organization),
]);
//# sourceMappingURL=conversation-summary.dto.js.map